import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="store-image"
export default class extends Controller {
  static targets = ["image", "placeholder", "avatar", "avatarImage"]
  
  connect() {
    // Verificar que existan los targets necesarios
    if (!this.hasImageTarget) {
      console.warn("store-image controller: missing image target")
      return
    }

    const img = this.imageTarget

    const showImage = () => {
      // Usar hasPlaceholderTarget para verificar existencia
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.remove()
      }
      img.classList.remove("invisible")
      img.classList.add("fade-in")
      
      // Mostrar el avatar logo cuando la imagen principal esté lista
      this.showAvatar()
    }

    const showAvatar = () => {
      if (this.hasAvatarTarget) {
        this.avatarTarget.style.opacity = "1"
      }
    }

    // Método público para mostrar avatar
    this.showAvatar = showAvatar

    if (img.complete) {
      showImage()
    } else {
      img.addEventListener("load", showImage)
    }
    
    // También cargar la imagen del avatar si existe
    if (this.hasAvatarImageTarget) {
      const avatarImg = this.avatarImageTarget
      if (avatarImg.complete) {
        // Avatar ya cargado, pero esperamos a la imagen principal
      } else {
        avatarImg.addEventListener("load", () => {
          // Avatar cargado, pero aún esperamos a la imagen principal
        })
      }
    }
  }
}
